import { render } from "./FiltrePurchaseHistory.vue?vue&type=template&id=22121195"
import script from "./FiltrePurchaseHistory.vue?vue&type=script&lang=ts"
export * from "./FiltrePurchaseHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script